import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bulkCancelEventsRequest = {};
var _bulkCancelEventsResponse = {};
var _bulkDeleteEventsRequest = {};
var _bulkDeleteEventsResponse = {};
var _cancelEventRequest = {};
var _cancelEventResponse = { event: '_event' };
var _copyEventRequest = {};
var _copyEventRequestV2 = {
    fields: 'google.protobuf.FieldMask',
    event: '_eventData',
};
var _copyEventResponse = { event: '_event' };
var _copyEventResponseV2 = { event: '_event' };
var _createEventRequest = { event: '_eventData' };
var _createEventResponse = { event: '_event' };
var _event = {
    created: 'google.protobuf.Timestamp',
    modified: 'google.protobuf.Timestamp',
    location: '_location',
    scheduling: '_scheduling',
    mainImage: '_image',
    registration: '_registration',
};
var _eventData = {
    location: '_location',
    scheduleConfig: '_scheduleConfig',
    mainImage: '_image',
    rsvpCollectionConfig: '_rsvpCollectionConfig',
};
var _findEventRequest = {};
var _findEventResponse = { event: '_event' };
var _getEventRequest = {};
var _getEventResponse = { event: '_event' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listEventsRequest = {};
var _listEventsResponse = { events: '_event' };
var _location = { coordinates: '_mapCoordinates', fullAddress: '_address' };
var _mapCoordinates = { lat: 'DOUBLE', lng: 'DOUBLE' };
var _occurrence = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _publishDraftEventRequest = {};
var _publishDraftEventResponse = { event: '_event' };
var _queryEventsRequest = {};
var _queryEventsResponse = { events: '_event' };
var _queryEventsV2Request = {};
var _queryEventsV2Response = { events: '_event' };
var _recurrences = { occurrences: '_occurrence' };
var _registration = { rsvpCollection: '_rsvpCollection' };
var _rsvpCollection = { config: '_rsvpCollectionConfig' };
var _rsvpCollectionConfig = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _scheduleConfig = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
    recurrences: '_recurrences',
};
var _scheduling = { config: '_scheduleConfig' };
var _updateEventRequest = {
    fields: 'google.protobuf.FieldMask',
    event: '_eventData',
};
var _updateEventResponse = { event: '_event' };
function resolveWixEventsEventManagementUrl(opts) {
    var domainToMappings = {
        'events._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
        ],
        'www.wixevents.com': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-web',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/events/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/events/v2',
                destPath: '/v2',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/rsvp',
                destPath: '/v1/rsvp',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/policies',
                destPath: '/v1/policies',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of up to 1,000 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
export function query(payload) {
    return function __query(_a) {
        var host = _a.host;
        var toJSON = serializer(_queryEventsRequest, {}).toJSON;
        var fromJSON = serializer(_queryEventsResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Retrieves a list of up to 1,000 events, given the provided paging, filtering and sorting.
 *
 * ** Important **:
 * - All results are for one specific business, resolved from the request context.
 *
 * Query object support:
 * - `filter` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
 * - `sort` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
 * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
 * - `fields` - not supported.
 * - `fieldsets` - not supported, use request-level `fieldset` instead.
 * - `cursorPaging` - not supported, use offset pagination instead.
 *
 * Defaults:
 * - When filter is not specified, returns all events that caller is authorized to read.
 * - When sorting is not specified, defaults to `created` in `DESC` order.
 */
export function queryV2(payload) {
    return function __queryV2(_a) {
        var host = _a.host;
        var toJSON = serializer(_queryEventsV2Request, {}).toJSON;
        var fromJSON = serializer(_queryEventsV2Response, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v2/events/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Retrieves a list of up to 100 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
export function list(payload) {
    return function __list(_a) {
        var host = _a.host;
        var toJSON = serializer(_listEventsRequest, {}).toJSON;
        var fromJSON = serializer(_listEventsResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Retrieves an event by ID or URL slug. */
export function get(payload) {
    return function __get(_a) {
        var host = _a.host;
        var toJSON = serializer(_getEventRequest, {}).toJSON;
        var fromJSON = serializer(_getEventResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/event',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Finds an event by ID or URL slug. In contrast to Get Event endpoint which returns not found error,
 * Find Event returns empty response when an event is not found.
 */
export function find(payload) {
    return function __find(_a) {
        var host = _a.host;
        var toJSON = serializer(_findEventRequest, {}).toJSON;
        var fromJSON = serializer(_findEventResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/event/find',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Creates a new event, with a default registration form in the given language.
 * Default registration form includes first name, last name, and email inputs.
 * To learn more about registration form and customize it, see [Registration Form](https://dev.wix.com/api/rest/wix-events/wix-events/registration-form/about-the-registration-form-api).
 * The event is automatically configured to send daily summary reports of new registrations to site business email.
 * RegistrationConfig.initialType is required - allowed value when creating is RSVP or TICKETS.
 */
export function createV2(payload) {
    return function __createV2(_a) {
        var host = _a.host;
        var toJSON = serializer(_createEventRequest, {
            _address: _address,
            _addressLocation: _addressLocation,
            _eventData: _eventData,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
        }).toJSON;
        var fromJSON = serializer(_createEventResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v2/events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
 * Multilingual translations are also copied to the new event.
 *
 * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
 * Very long event titles are cropped: "Daily stand-up ev... (2)".
 */
export function copy(payload) {
    return function __copy(_a) {
        var host = _a.host;
        var toJSON = serializer(_copyEventRequest, {}).toJSON;
        var fromJSON = serializer(_copyEventResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{eventId}/copy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
 * Multilingual translations are also copied to the new event.
 * Supports partial update of the original event fields. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
 *
 * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
 * Very long event titles are cropped: "Daily stand-up ev... (2)".
 */
export function copyV2(payload) {
    return function __copyV2(_a) {
        var host = _a.host;
        var toJSON = serializer(_copyEventRequestV2, {
            _address: _address,
            _addressLocation: _addressLocation,
            _eventData: _eventData,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
        }).toJSON;
        var fromJSON = serializer(_copyEventResponseV2, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v2/events/{id}/copy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Updates an event's parameters. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information. */
export function update(payload) {
    return function __update(_a) {
        var host = _a.host;
        var toJSON = serializer(_updateEventRequest, {
            _address: _address,
            _addressLocation: _addressLocation,
            _eventData: _eventData,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
        }).toJSON;
        var fromJSON = serializer(_updateEventResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Publishes draft event so that it becomes available to site visitors.
 * If recurring events are set, category with state RECURRING_EVENT will be created.
 * All recurring events will be assigned to this category.
 */
export function publishDraft(payload) {
    return function __publishDraft(_a) {
        var host = _a.host;
        var toJSON = serializer(_publishDraftEventRequest, {}).toJSON;
        var fromJSON = serializer(_publishDraftEventResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{id}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Cancels an event and closes registration.
 * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
 */
export function cancel(payload) {
    return function __cancel(_a) {
        var host = _a.host;
        var toJSON = serializer(_cancelEventRequest, {}).toJSON;
        var fromJSON = serializer(_cancelEventResponse, {
            _address: _address,
            _addressLocation: _addressLocation,
            _event: _event,
            _image: _image,
            _location: _location,
            _mapCoordinates: _mapCoordinates,
            _occurrence: _occurrence,
            _recurrences: _recurrences,
            _registration: _registration,
            _rsvpCollection: _rsvpCollection,
            _rsvpCollectionConfig: _rsvpCollectionConfig,
            _scheduleConfig: _scheduleConfig,
            _scheduling: _scheduling,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/events/{id}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Cancels events by filter.
 * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
 */
export function bulkCancel(payload) {
    return function __bulkCancel(_a) {
        var host = _a.host;
        var toJSON = serializer(_bulkCancelEventsRequest, {}).toJSON;
        var fromJSON = serializer(_bulkCancelEventsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/bulk/events/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Deletes events by filter.
 * Deleted events are not returned via API. The only way to retrieve them is via GDPR access request.
 */
export function bulkDelete(payload) {
    return function __bulkDelete(_a) {
        var host = _a.host;
        var toJSON = serializer(_bulkDeleteEventsRequest, {}).toJSON;
        var fromJSON = serializer(_bulkDeleteEventsResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixEventsEventManagementUrl({
                protoPath: '/v1/bulk/events/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map